<script>
import moment from 'moment'
import { nToWord } from '@/utils/helpers'
import SidebarPenalties from '@/components/views/penalties/SidebarPenalties.vue'

export default {
  name: 'bookings',
  components: {
    SidebarPenalties
  },
  data: () => ({
    active: true
  }),
  computed: {
    hasBookedServices() {
      return this.$store.getters['order/hasBookedServices']
    },
    getBookingsStatuses() {
      return this.$store.getters['order/getInclude'].bookingStatuses
    },
    getBookingsServices() {
      return this.$store.getters['order/getBookingsServices']
    },
    getOrderInfo() {
      return this.$store.getters['order/getOrderInfo']
    },
    isLoading() {
      return this.$store.getters['order/isLoading']
    },
    getNumberOfTourists() {
      return this.$store.getters['order/getNumberOfTourists']
    }
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
    formatTime: date => moment.unix(date).format('HH:mm'),
    calcDuration: (startDate, endDate) => {
      const start = moment.unix(startDate).format('YYYY-MM-DD')
      const end = moment.unix(endDate).format('YYYY-MM-DD')

      const count = moment.duration(
        moment(end, 'YYYY-MM-DD').diff(moment(start, 'YYYY-MM-DD'), 'days'), 'days'
      ).asDays()

      return `${count} ${nToWord(count, ['ночь', 'ночи', 'ночей'])}`
    },
    aviaticketsList: directions => [].concat(...directions),
    getBookingStatus(status) {
      return this.getBookingsStatuses[status]
    }
  }
}
</script>

<template>
  <div
    v-if="hasBookedServices"
    class="rex-spoiler order-booking"
  >
    <div
      class="rex-spoiler__header rex-spoiler__header--active"
    >
      <h3>Услуги заказа № {{ getOrderInfo.id }}</h3>
    </div>
    <div
      class="rex-spoiler__content"
    >
      <b-loading
        :is-full-page="false"
        :active="isLoading"
      />
      <div v-if="!isLoading">
        <div class="order-booking__services-list-header">
          <p class="order-booking__services-list-header-item">
            Услуга
          </p>
          <p class="
              order-booking__services-list-header-item
              order-booking__services-list-header-item--centered
            "
          >
            Кол-во человек
          </p>
          <p class="order-booking__services-list-header-item">
            Статус
          </p>
          <p class="order-booking__services-list-header-item">
            Отмена
          </p>
        </div>
        <template
          v-if="getBookingsServices['excursions']"
        >
          <div
            v-for="(excursion, excursionIndex) in getBookingsServices['excursions']"
            :key="`excursionService${excursionIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Экскурсия
              </h3>
              <div class="order-booking__service-details-row">
                <p>
                  {{ excursion.name }}
                </p>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ excursion.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[excursion.status] }}
            </div>
            <div class="order-booking__service-info">
              <sidebar-penalties
                store-module="order"
                getter-name="getAllBookingsPenalties"
                link-text="Условия"
                :target="excursion.bookingId"
              />
            </div>
          </div>
        </template>
        <template
          v-if="getBookingsServices['aviatickets']"
        >
          <div
            v-for="(avia, aviaIndex) in getBookingsServices['aviatickets']"
            :key="`aviaticketsService${aviaIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Авиаперелет
              </h3>
              <div
                v-for="(flight, flightIndex) in aviaticketsList(avia.directions)"
                :key="`aviaticketsService${aviaIndex}flight${flightIndex}`"
                class="order-booking__service-details-row"
              >
                <p>
                  {{ `${flight.departure.cityName}-${flight.arrival.cityName}` }}
                </p>
                <p>
                  {{ formatDate(flight.departure.date) }}
                </p>
                <p>
                  {{ `${formatTime(flight.departure.date)} - ${formatTime(flight.arrival.date)}` }}
                </p>
                <p>
                  {{ `${avia.validatingCarrierCode} ${flight.carrierNumber}` }}
                </p>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ avia.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[avia.status] }}
            </div>
            <div class="order-booking__service-info" />
          </div>
        </template>
        <template
          v-if="getBookingsServices['hotels']"
        >
          <div
            v-for="(hotel, hotelIndex) in getBookingsServices['hotels']"
            :key="`hotelService${hotelIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Отель
              </h3>
              <div class="order-booking__service-details-row">
                <p>
                  {{ hotel.details.name }}
                </p>
                <p>
                  {{ formatDate(hotel.startDate) }}
                </p>
                <p>
                  {{ calcDuration(hotel.startDate, hotel.endDate) }}
                </p>
                <div>
                  <p
                    v-for="(accommodation, accommodationId) in hotel.accommodation.rooms"
                    :key="`hotelService${hotelIndex}accommodation${accommodationId}`"
                  >
                    {{ accommodation.name }}<br>{{ hotel.accommodation.mealType.nameRu }}
                  </p>
                </div>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ hotel.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[hotel.status] }}
            </div>
            <div class="order-booking__service-info">
              <sidebar-penalties
                store-module="order"
                getter-name="getAllBookingsPenalties"
                link-text="Условия"
                :target="hotel.bookingId"
              />
            </div>
          </div>
        </template>
        <template
          v-if="getBookingsServices['transfers']"
        >
          <div
            v-for="(transfer, transferIndex) in getBookingsServices['transfers']"
            :key="`transferService${transferIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Трансфер
              </h3>
              <div
                class="
                  order-booking__service-details-row
                  order-booking__service-details-row--collapse-last
                "
              >
                <div>
                  <p>
                    {{ transfer.name }}
                  </p>
                  <p>
                    {{ `(${transfer.group}, ${transfer.maximumPassengers})` }}
                  </p>
                </div>
                <p>
                  {{ formatDate(transfer.startDate) }}
                </p>
                <div>
                  <!-- <p
                    v-for="(route, routeIndex) in transfer.routes"
                    :key="`transfer${transferIndex}route${routeIndex}`"
                  >
                    {{ `${route.pointFrom.name} → ${route.pointTo.name}` }}
                  </p> -->
                </div>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ transfer.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[transfer.status] }}
            </div>
            <div class="order-booking__service-info">
              <sidebar-penalties
                store-module="order"
                getter-name="getAllBookingsPenalties"
                link-text="Условия"
                :target="transfer.bookingId"
              />
            </div>
          </div>
        </template>
        <template
          v-if="getBookingsServices['insurances']"
        >
          <div
            v-for="(insurance, insuranceIndex) in getBookingsServices['insurances']"
            :key="`insuranceService${insuranceIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Страховка
              </h3>
              <div class="order-booking__service-details-row">
                <p>Страховка от невыезда</p>
                <div>
                  <p>
                    {{ formatDate(insurance.startDate) }}-
                  </p>
                  <p>
                    {{ formatDate(insurance.endDate) }}
                  </p>
                </div>
                <p>
                  {{ insurance.name }}
                </p>
                <p>
                  Получение в Москве
                </p>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ insurance.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[insurance.status] }}
            </div>
            <div class="order-booking__service-info">
              <sidebar-penalties
                store-module="order"
                getter-name="getAllBookingsPenalties"
                link-text="Условия"
                :target="insurance.bookingId"
              />
            </div>
          </div>
        </template>
        <template
          v-if="getBookingsServices['visas']"
        >
          <div
            v-for="(visa, visaIndex) in getBookingsServices['visas']"
            :key="`visaService${visaIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Виза
              </h3>
              <div class="order-booking__service-details-row">
                <div>
                  <p
                    v-for="(tourist, toristsIndex) in visa.tourists"
                    :key="`visaService${visaIndex}tourist${toristsIndex}`"
                  >
                    Турист {{ toristsIndex+1 }}: {{ tourist.visaName }} ({{ tourist.ageInfo }})
                  </p>
                </div>
                <div>
                  {{ visa.countryName }}
                </div>
                <div>
                  {{ formatDate(visa.startDate) }}-{{ formatDate(visa.endDate) }}
                </div>
                <div>
                  Место получения: {{ visa.countryFrom }}
                </div>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ visa.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[visa.status] }}
            </div>
          </div>
        </template>
        <template
          v-if="getBookingsServices['additional']"
        >
          <div
            v-for="(additional, additionalIndex) in getBookingsServices['additional']"
            :key="`additionalService${additionalIndex}`"
            class="order-booking__service"
          >
            <div class="order-booking__service-details">
              <h3 class="order-booking__service-name">
                Дополнительная услуга
              </h3>
              <div class="order-booking__service-details-row">
                <div>
                  <p>
                    {{ additional.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="order-booking__service-info order-booking__service-info--centered">
              {{ additional.touristsCount }}
            </div>
            <div class="order-booking__service-info">
              {{ getBookingsStatuses[additional.status] }}
            </div>
            <div class="order-booking__service-info">
              <sidebar-penalties
                store-module="order"
                getter-name="getAllBookingsPenalties"
                link-text="Условия"
                :target="additional.bookingId"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
